import { useState, useEffect } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaBars,
  FaTimes,
} from "react-icons/fa";


export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const whatsappURL =
    "https://wa.me/919790964195?text=Hello! 👋 I want to join Hunters Cricket Academy";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Go to home and then scroll to section
  const goToSection = (section) => {
    setMenuOpen(false);

    if (location.pathname === "/") {
      const element = document.getElementById(section);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else {
      navigate("/");

      setTimeout(() => {
        const element = document.getElementById(section);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    }
  };

  return (
    <>
      {/* NAVBAR */}
      <nav
        className={`fixed w-full z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/90 backdrop-blur-md shadow-lg py-3"
            : "bg-gradient-to-b from-black/60 to-transparent py-5"
        }`}
      >
        <div className="flex justify-between items-center px-6 md:px-10">

          {/* LOGO */}
          <div className="flex items-center gap-3">

            <RouterLink to="/">
              <img
                src="/logo.jpeg"
                alt="logo"
                className={`transition-all duration-300 ${
                  scrolled ? "h-16" : "h-20"
                }`}
              />
            </RouterLink>

            <RouterLink
              to="/"
              className={`font-bold text-gold transition-all duration-300 ${
                scrolled
                  ? "text-black text-xl"
                  : "text-white text-2xl md:text-3xl drop-shadow-md"
              }`}
            >
              Hunters Cricket Academy
            </RouterLink>

          </div>

          {/* DESKTOP MENU */}
          <ul
            className={`hidden md:flex space-x-6 font-semibold items-center transition ${
              scrolled ? "text-black" : "text-white"
            }`}
          >

            {/* HOME */}
            <li>
              <RouterLink
                to="/"
                className="cursor-pointer hover:text-gold transition"
              >
                Home
              </RouterLink>
            </li>

            {/* ABOUT */}
            <li>
              <button
                onClick={() => goToSection("about")}
                className="cursor-pointer hover:text-gold transition"
              >
                About
              </button>
            </li>

            {/* PROGRAMS */}
            <li>
              <button
                onClick={() => goToSection("programs")}
                className="cursor-pointer hover:text-gold transition"
              >
                Programs
              </button>
            </li>

            {/* GALLERY */}
            <li className="relative group">

              <button className="cursor-pointer hover:text-gold transition">
                Gallery ▾
              </button>

              <div className="absolute left-0 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">

                <div className="bg-white text-black rounded-xl shadow-2xl overflow-hidden min-w-[180px]">

                  <button
                    onClick={() => goToSection("photos")}
                    className="block w-full text-left px-5 py-3 hover:bg-gray-100 cursor-pointer"
                  >
                    📸 Photos
                  </button>

                  <button
                    onClick={() => goToSection("videos")}
                    className="block w-full text-left px-5 py-3 hover:bg-gray-100 cursor-pointer"
                  >
                    🎥 Videos
                  </button>

                </div>
              </div>
            </li>

            {/* BOOKING */}
            <li>
              <RouterLink
                to="/booking"
                className="cursor-pointer hover:text-gold transition"
              >
                Booking
              </RouterLink>
            </li>

            {/* CONTACT */}
            <li>
              <button
                onClick={() => goToSection("contact")}
                className="cursor-pointer hover:text-gold transition"
              >
                Contact
              </button>
            </li>

            {/* SOCIAL */}
            <li
              className={`flex gap-4 text-xl ml-4 ${
                scrolled ? "text-black" : "text-white"
              }`}
            >
              <FaFacebook className="hover:text-gold cursor-pointer" />
              <FaInstagram className="hover:text-gold cursor-pointer" />
              <FaYoutube className="hover:text-gold cursor-pointer" />
            </li>

          </ul>

          {/* MOBILE BUTTON */}
          <div className="md:hidden">
            <button onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>

        </div>

        {/* MOBILE MENU */}
        {menuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-white/95 backdrop-blur-md shadow-xl rounded-b-2xl border-t border-gray-200">

            <ul className="flex flex-col space-y-5 p-6 text-center">

              {/* HOME */}
              <li>
                <RouterLink
                  to="/"
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer hover:text-gold transition"
                >
                  Home
                </RouterLink>
              </li>

              {/* ABOUT */}
              <li>
                <button
                  onClick={() => goToSection("about")}
                  className="cursor-pointer hover:text-gold transition"
                >
                  About
                </button>
              </li>

              {/* PROGRAMS */}
              <li>
                <button
                  onClick={() => goToSection("programs")}
                  className="cursor-pointer hover:text-gold transition"
                >
                  Programs
                </button>
              </li>

              {/* GALLERY */}
              <li>

                <button className="cursor-pointer hover:text-gold transition">
                  Gallery ▾
                </button>

                <div className="mt-3 bg-white text-black rounded-xl shadow-lg overflow-hidden">

                  <button
                    onClick={() => goToSection("photos")}
                    className="block w-full px-5 py-3 hover:bg-gray-100"
                  >
                    📸 Photos
                  </button>

                  <button
                    onClick={() => goToSection("videos")}
                    className="block w-full px-5 py-3 hover:bg-gray-100"
                  >
                    🎥 Videos
                  </button>

                </div>

              </li>

              {/* BOOKING */}
              <li>
                <RouterLink
                  to="/booking"
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer hover:text-gold transition"
                >
                  Booking
                </RouterLink>
              </li>

              {/* CONTACT */}
              <li>
                <button
                  onClick={() => goToSection("contact")}
                  className="cursor-pointer hover:text-gold transition"
                >
                  Contact
                </button>
              </li>

            </ul>

          </div>
        )}

      </nav>

      {/* WHATSAPP */}
      <div className="fixed bottom-5 right-5 z-50">

        <a
          href={whatsappURL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-green-500 text-white px-4 py-3 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition"
        >
          <FaWhatsapp />
          Chat
        </a>

      </div>
    </>
  );
}